export default __webpack_public_path__ + "static/Quickinstallation_Tile_9008_Step_20-31535b69a86d060e868fa43d7366688c.webp";